<template>
  <div class="applicant-reset-dialog">
    <el-dialog custom-class="with-title" :title="displayText + '解除'" :visible.sync="visible" :show-close="!loading">
      <div v-loading="loading">
        <div class="dialog-content">
          <div class="message message-error mb-x3">
            <div>{{ displayText + 'を一括解除してよろしいですか?' }}</div>
            <div>この操作は取り消しできません。</div>
          </div>
        </div>
        <div class="input-container" v-if="isWinnerType">
          <el-switch
            v-model="excludeSentMessage"
            active-text="メッセージを配信したユーザーを除外"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </div>
        <div class="dialog-footer" slot="footer">
          <div layout layout-align="end-center">
            <el-tooltip
              placement="top"
              :disabled="!(isDmSending && type === 'winner')"
              content="DM送信中のため当選者解除はできません"
            >
              <div>
                <el-button type="primary" @click="submit()" :disabled="disabled"
                  ><i class="mdi mdi-playlist-play"></i>一括解除を実行</el-button
                >
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import api from '@/client/core/api'
import { useTwitterApplicantStore } from '@/client/store/useTwitterApplicantStore'

export default defineComponent({
  data() {
    return {
      type: '',
      visible: false,
      loading: false,
      isSubmit: false,
      excludeSentMessage: 1
    }
  },
  computed: {
    ...mapState(useTwitterApplicantStore, {
      prizeId: state => state.campaignPrize?.id,
      isDmSending: state => state.isDmSending
    }),
    displayText() {
      let displayText = this.type
      switch (displayText) {
        case 'winner':
          return (displayText = '当選者')

        case 'responder':
          return (displayText = '回答者')

        case 'candidate':
          return (displayText = '候補者')
      }
    },
    isWinnerType() {
      return this.type === 'winner'
    },
    disabled() {
      // DM送信中の場合は当選者解除のみ無効化
      return this.isSubmit || (this.isDmSending && this.type === 'winner')
    }
  },
  methods: {
    ...mapActions(useTwitterApplicantStore, ['fetchApplicants', 'fetchCampaignPrize']),

    /**
     * ダイアログをリセット
     */
    reset() {
      this.loading = false
      this.isSubmit = false
    },

    /**
     * フォームのサブミット
     */
    async submit() {
      if (this.isSubmit) {
        return
      }

      this.isSubmit = true
      this.loading = true

      const params: { prizeId: number | undefined; type: string; excludeSentMessage?: boolean } = {
        prizeId: this.prizeId,
        type: this.type
      }

      if (this.type === 'winner') {
        params.excludeSentMessage = this.excludeSentMessage === 1
      }

      const result = await api.post('/twitter_applicants/resets', params)

      this.loading = false
      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      // エラーハンドリング
      if (result && result.error && result.error.type === 'DM_SENDING_IN_PROGRESS') {
        this.$notify({
          title: 'DM送信中のため当選者解除はできません。',
          message: 'DM送信が終了してから再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        this.fetchCampaignPrize()
        this.fetchApplicants()
        return
      }

      // 失敗した場合はエラーを表示
      if (!result.data) {
        this.$notify({
          title: `${this.displayText}の一括解除に失敗しました。`,
          message: '恐れ入りますが、時間を置いて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      // 成功メッセージを表示
      this.$notify({
        title: `${this.displayText}を一括解除しました。`,
        message: '',
        customClass: 'success',
        duration: 5000
      })

      this.fetchCampaignPrize()
      this.fetchApplicants()
      this.close()
    },

    open(type: string) {
      this.type = type
      this.visible = true
      this.reset()
    },
    close() {
      this.visible = false
    }
  }
})
</script>
